export enum Constants {
  SET_COMPANIES = 'SET_COMPANIES',
  ADD_COMPANY = 'ADD_COMPANY',
  UPDATE_COMPANY = 'UPDATE_COMPANY',
  REMOVE_COMPANY = 'REMOVE_COMPANY',
}